import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cancel-popup',
  templateUrl: './cancel-popup.component.html',
  styleUrls: ['./cancel-popup.component.scss'],
})
export class CancelPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<CancelPopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { cancelMessage: string; cancelContext: string },
  ) {}
}
